var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.getData
    ? _c(
        "PanelRow",
        [
          _c("Panel", { staticClass: "newcontest" }, [
            _c("p", { staticClass: "main-title mb-3" }, [
              _vm._v("Bounty Detail")
            ]),
            _vm._v(" "),
            _vm.first_name
              ? _c("div", {}, [
                  _c(
                    "table",
                    { staticClass: "table compaign-form details-form" },
                    [
                      _c("tbody", [
                        _c("tr", [
                          _c("th", { attrs: { scope: "row" } }, [
                            _vm._v("Task ID :")
                          ]),
                          _vm._v(" "),
                          _c("td", [_vm._v(_vm._s(_vm.task_id))])
                        ]),
                        _vm._v(" "),
                        _c("tr", [
                          _c("th", { attrs: { scope: "row" } }, [
                            _vm._v("User Name :")
                          ]),
                          _vm._v(" "),
                          _c("td", [
                            _vm._v(
                              _vm._s(_vm.first_name) +
                                " " +
                                _vm._s(_vm.last_name)
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        _c("tr", [
                          _c("th", { attrs: { scope: "row" } }, [
                            _vm._v("User Email ID :")
                          ]),
                          _vm._v(" "),
                          _c("td", [_vm._v(_vm._s(_vm.email))])
                        ]),
                        _vm._v(" "),
                        _c("tr", [
                          _c("th", { attrs: { scope: "row" } }, [
                            _vm._v("Company Name :")
                          ]),
                          _vm._v(" "),
                          _c("td", [_vm._v(_vm._s(_vm.company_name))])
                        ]),
                        _vm._v(" "),
                        _c("tr", [
                          _c("th", { attrs: { scope: "row" } }, [
                            _vm._v("Company Email ID :")
                          ]),
                          _vm._v(" "),
                          _c("td", [_vm._v(_vm._s(_vm.company_email))])
                        ]),
                        _vm._v(" "),
                        _c("tr", [
                          _c("th", { attrs: { scope: "row" } }, [
                            _vm._v("Request date :")
                          ]),
                          _vm._v(" "),
                          _c("td", [
                            _vm._v(_vm._s(_vm._f("formatDate")(_vm.date)))
                          ])
                        ]),
                        _vm._v(" "),
                        _c("tr", [
                          _c("th", { attrs: { scope: "row" } }, [
                            _vm._v("Project :")
                          ]),
                          _vm._v(" "),
                          _c("td", [_vm._v(_vm._s(_vm.project))])
                        ]),
                        _vm._v(" "),
                        _c("tr", [
                          _c("th", { attrs: { scope: "row" } }, [
                            _vm._v("Project Description :")
                          ]),
                          _vm._v(" "),
                          _c("td", [_vm._v(_vm._s(_vm.project_description))])
                        ]),
                        _vm._v(" "),
                        _c("tr", [
                          _c("th", { attrs: { scope: "row" } }, [
                            _vm._v("Campaign :")
                          ]),
                          _vm._v(" "),
                          _c("td", [_vm._v(_vm._s(_vm.compaign))])
                        ]),
                        _vm._v(" "),
                        _c("tr", [
                          _c("th", { attrs: { scope: "row" } }, [
                            _vm._v("Bounty Type :")
                          ]),
                          _vm._v(" "),
                          _c("td", [_vm._v(_vm._s(_vm.bounty_type))])
                        ]),
                        _vm._v(" "),
                        _c("tr", [
                          _c("th", { attrs: { scope: "row" } }, [
                            _vm._v("Campaign Description :")
                          ]),
                          _vm._v(" "),
                          _c("td", [_vm._v(_vm._s(_vm.compaign_description))])
                        ]),
                        _vm._v(" "),
                        _c("tr", [
                          _c("th", { attrs: { scope: "row" } }, [
                            _vm._v("Start Date :")
                          ]),
                          _vm._v(" "),
                          _c("td", [
                            _vm._v(_vm._s(_vm._f("formatDate")(_vm.start_date)))
                          ])
                        ]),
                        _vm._v(" "),
                        _c("tr", [
                          _c("th", { attrs: { scope: "row" } }, [
                            _vm._v("End Date :")
                          ]),
                          _vm._v(" "),
                          _c("td", [
                            _vm._v(_vm._s(_vm._f("formatDate")(_vm.end_date)))
                          ])
                        ]),
                        _vm._v(" "),
                        _c("tr", [
                          _c("th", { attrs: { scope: "row" } }, [
                            _vm._v("Paid Amount :")
                          ]),
                          _vm._v(" "),
                          _c("td", [
                            _vm._v(
                              _vm._s(_vm.totalPaid) +
                                " " +
                                _vm._s(_vm.tokenTicker)
                            )
                          ])
                        ])
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "details-form" }, [
                    _c("div", { staticClass: "m-textbox" }, [
                      _c("label", { attrs: { for: "exampleInputEmail1" } }, [
                        _vm._v("Status: ")
                      ]),
                      _vm._v(" "),
                      _c(
                        "select",
                        {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.selStatus,
                              expression: "selStatus"
                            }
                          ],
                          staticClass: "custom-select",
                          attrs: { name: "selStatus", id: "selStatus" },
                          on: {
                            change: function($event) {
                              var $$selectedVal = Array.prototype.filter
                                .call($event.target.options, function(o) {
                                  return o.selected
                                })
                                .map(function(o) {
                                  var val = "_value" in o ? o._value : o.value
                                  return val
                                })
                              _vm.selStatus = $event.target.multiple
                                ? $$selectedVal
                                : $$selectedVal[0]
                            }
                          }
                        },
                        [
                          _c("option", { attrs: { value: "Published" } }, [
                            _vm._v("Published")
                          ]),
                          _vm._v(" "),
                          _c("option", { attrs: { value: "Unpublished" } }, [
                            _vm._v("Unpublished")
                          ])
                        ]
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "half-width-textbox" }, [
                    _c(
                      "button",
                      {
                        staticClass: "save-btn",
                        attrs: { type: "button", id: "submitData" },
                        on: { click: _vm.submitData }
                      },
                      [_vm._v("\n          Save Changes\n        ")]
                    )
                  ])
                ])
              : _c("div", { staticClass: "briefinfo" }, [
                  _c("div", { staticClass: "timeline csmt-width" }, [
                    _c("p", { staticClass: "over-timeline-title" }, [
                      _vm._v("No data found")
                    ])
                  ])
                ])
          ])
        ],
        1
      )
    : _c("Loading")
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-d7fc1e0a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d7fc1e0a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/sections/general/BountyDetail.vue
// module id = null
// module chunks = 